import { lazy } from 'react';
import { retry } from '../../../config/utils';

const Bank = lazy(() => retry(()=> import(/* webpackChunkName: "Bank" */ "./Bank")));

export default Bank;